export default "__VITE_ASSET__RZDPO$7D__"